<template>
  <div>
    <el-dialog
      :visible="innerVisible"
      :title="$t('SeaExport.Edit')"
      width="1370px"
      custom-class="edit-dialog"
      top="5vh"
      :close-on-click-modal="false"
      @close="handleClose"
    >
      <el-form label-width="85px" label-position="left">
        <div class="form-content-wrapper">
          <div class="up">
            <fieldset>
              <legend>{{ $t('SeaExport.ConsignInfo') }}</legend>

              <el-form-item>
                <span slot="label" class="blue">{{ $t('SeaExport.ConsignationCompany') }}</span>
                <cargo-company-select
                  ref="customerSelect"
                  class="shipper-selector"
                  popper-class="shipper-selector-popper"
                  :method-params="{customer:true,companyLob:'railwayExport',active:true}"
                  :check-credit="true"
                  :job="form"
                  :default-value="form.customerId||''"
                  @change="p=>{customerIdChange2ContractHandler(p)}"
                />
              </el-form-item>
              <el-form-item
                :label="$t('SeaExport.LocalService')"
                label-width="85px"
              >
                <el-checkbox
                  v-model="form.warehousing"
                >{{ $t('SeaExport.WarehouseLoadingStorage') }}
                </el-checkbox>
                <el-checkbox
                  v-model="form.landTransportation"
                >{{ $t('SeaExport.DoorLoadingDelivery') }}
                </el-checkbox>
                <el-checkbox
                  v-model="form.selfDeliver"
                >{{ $t('SeaExport.NotResponsibleForTruckingAndLoading') }}
                </el-checkbox>
              </el-form-item>
            </fieldset>
            <fieldset>
              <legend>{{ $t('SeaExport.ContainerInfo2') }}</legend>
              <el-form-item
                v-show="form.containerLoadType==='FCL'||form.containerLoadType==='BB'"
                label-width="0"
                class="custom"
              >
                <booking-sea-eq-data-grid
                  ref="bookingSeaEqDataGrid"
                  :value="seaEqList"
                  :container-load-type="form.containerLoadType"
                  :is-edit="isEdit"
                  :job="form"
                />
              </el-form-item>
              <el-form-item v-show="form.containerLoadType==='BULK'" label-width="0" class="custom">
                <booking-bulk-data-grid
                  :value="cargoBulkDetailList"
                  :job-uuid="form.uuid"
                  :is-edit="isEdit"
                />
              </el-form-item>
              <el-form-item v-show="form.containerLoadType==='SPA'" label-width="0" class="custom">
                <booking-special-data-grid
                  :value="seaEqList"
                  :is-edit="isEdit"
                  :job="form"
                />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.QuantityConsignActual')" class="custom" label-width="100px">
                <div style="display: flex">
                  <div style="display:flex;flex: 1">
                    <auto-number-input
                      v-model="form.quantityContract"
                      :precision="0"
                      :min="0"
                      @change="jobContractQwcChange(1)"
                    />
                    <span style="padding:0 2px;">/</span>
                    <auto-number-input
                      v-model="form.quantityActual"
                      :precision="0"
                      :min="0"
                      @change="SEUtils.changeQWCRule(null,()=>{form.quantityContract=form.quantityActual});"
                    />
                  </div>
                  <span style="width: 30px">PCS</span>
                </div>
              </el-form-item>
              <el-form-item :label="$t('SeaExport.WeightConsignActual')" class="custom" label-width="100px">
                <div style="display: flex">
                  <div style="display:flex;flex: 1">
                    <auto-number-input
                      v-model="form.weightContract"
                      :precision="3"
                      :min="0"
                      @change="jobContractQwcChange(2)"
                    />
                    <span style="padding:0 2px;">/</span>
                    <auto-number-input
                      ref="weightActual"
                      v-model="form.weightActual"
                      :precision="3"
                      :min="0"
                      @change="SEUtils.changeQWCRule(null,()=>{form.weightContract=form.weightActual});calculateChargeWeight();"
                    />
                  </div>
                  <span style="width: 30px">KGS</span>
                </div>
              </el-form-item>
              <el-form-item :label="$t('SeaExport.CubageConsignActual')" class="custom" label-width="100px">
                <div style="display: flex">
                  <div style="display:flex;flex: 1">
                    <auto-number-input
                      v-model="form.cubageContract"
                      :precision="3"
                      :min="0"
                      @change="jobContractQwcChange(3)"
                    />
                    <span style="padding:0 2px;">/</span>
                    <auto-number-input
                      ref="cubageActual"
                      v-model="form.cubageActual"
                      :precision="3"
                      :min="0"
                      @change="SEUtils.changeQWCRule(null,()=>{form.cubageContract=form.cubageActual;form.chargeWeight=form.cubageActual});calculateChargeWeight();"
                    />
                  </div>
                  <span style="width: 30px">CBM</span>
                </div>
              </el-form-item>
            </fieldset>
            <fieldset style="width: min-content">
              <legend>{{ $t('SeaExport.CargoInfo') }}</legend>
              <el-form-item :label="$t('SeaExport.EnglishDescriptionOfGoods')" class="custom">
                <cargo-rich-textarea
                  v-model="form.cargoEnglishName"
                  style="height: 110px"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.EnglishDescriptionOfGoods'),form.cargoEnglishName,val=>{form.cargoEnglishName=val})"
                />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.Marks')" class="custom">
                <cargo-rich-textarea
                  v-model="form.mark"
                  style="height: 110px"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.Marks'),form.mark,val=>{form.mark=val})"
                />
              </el-form-item>
              <el-form-item class="custom">
                <div slot="label">
                  <span>{{ $t('SeaExport.HsCode') }}</span>
                  <br>
                  <el-button
                    v-show="isEdit"
                    type="primary"
                    @click="showHsCodeSearchDialog($t('Message.SelectHsCode'),p=>form.hsCode=p.code)"
                  >{{ $t('SeaExport.Search') }}</el-button>
                </div>
                <el-input
                  v-model="form.hsCode"
                  type="textarea"
                  :rows="5"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.HsCode'),form.hsCode,val=>{form.hsCode=val})"
                />
              </el-form-item>
              <el-form-item class="custom">
                <div slot="label">
                  <span>{{ $t('SeaExport.ChineseDescriptionOfGoods') }}</span>
                  <br>
                </div>
                <cargo-rich-textarea
                  v-model="form.cargoChineseName"
                  :auto-uppercase="false"
                  :auto-half-word="false"
                  style="height: 110px"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.ChineseDescriptionOfGoods'),form.cargoChineseName,val=>{form.cargoChineseName=val})"
                />
              </el-form-item>
            </fieldset>
            <fieldset>
              <legend>{{ $t('SeaExport.OperationInfo') }}</legend>
              <el-form-item>
                <span slot="label" class="blue">{{ $t('SeaExport.Sales') }}</span>
                <div style="display: flex;justify-content: space-between">
                  <cargo-user-select
                    ref="sales"
                    :method-params="{officeId:salesOfficeCheck?$store.getters.currentOfficeId:'',category:'role',shape:'sales'}"
                    :default-value="form.sales||''"
                    :static-options="salesList"
                    :placeholder="salesPrompt"
                    style="flex: 1"
                    @change="p=>{form.sales = p.value}"
                  />&nbsp;
                  <el-checkbox v-model="form.provisioned" style="margin-left: 5px" :disabled="true">
                    {{ $t('SeaExport.Accrued') }}
                  </el-checkbox>
                </div>
              </el-form-item>
              <el-form-item>
                <span slot="label" class="blue">{{ $t('SeaExport.OperationDepartment') }}</span>
                <cargo-department-select
                  :office-id="Number(form.opOffice)"
                  :department-id="Number(form.opDepartment)"
                  @change="p=>{form.opDepartment = p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.Operation')">
                <cargo-user-select
                  :method-params="{officeId:form.opOffice,category:'role',shape:'op'}"
                  :default-value="form.op||''"
                  @change="p=>{form.op = p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.Documents')">
                <cargo-user-select
                  ref="dc"
                  :method-params="{officeId:form.opOffice,category:'role',shape:'doc'}"
                  :default-value="form.dc||''"
                  @change="p=>{form.dc = p.value}"
                />
              </el-form-item>
            </fieldset>
          </div>
          <div class="down">
            <fieldset>
              <legend>{{ $t('SeaExport.CustomerDeliveryInfo') }}</legend>
              <div class="custom-delivery-info-wrapper">
                <div>
                  <el-form-item :label="$t('SeaExport.Shipper')" class="custom">
                    <cargo-company-select
                      :method-params="{shipper:true,active:true}"
                      :default-value="form.shipperId||''"
                      style="display: inline-block;width:173px;"
                      @change="data => {shipperChange(data)}"
                    />&nbsp;
                    <el-button
                      type="primary"
                      @click="billAddressDialog.visible=true"
                    >{{ $t('SeaExport.CodeSearching') }}</el-button>
                  </el-form-item>
                  <el-form-item v-for="i in 7" :key="i" class="label-none custom">
                    <cargo-input
                      :ref="'shipperLine'+i"
                      v-model="form['shipperLine'+i]"
                      :auto-uppercase="true"
                      @change="()=>wrapAddr(form,'shipperLine'+i,i+1 > 6 ? null :'shipperLine'+(i+1),45)"
                      @dblclick.native="showAdvanceTextDialog($t('SeaExport.Shipper'),mergeShipperLine(),splitShipperLine,true)"
                    />
                  </el-form-item>
                </div>
                <div>
                  <el-form-item :label="$t('SeaExport.Consignee')" class="custom">
                    <cargo-company-select
                      :method-params="{consignee:true,active:true}"
                      :default-value="form.consigneeId||''"
                      style="display: inline-block;width:173px;"
                      @change="data => {consigneeChange(data)}"
                    />&nbsp;
                    <el-button
                      type="primary"
                      @click="billAddressDialog.visible=true"
                    >{{ $t('SeaExport.CodeSearching') }}</el-button>
                  </el-form-item>
                  <el-form-item v-for="i in 7" :key="i" class="label-none custom">
                    <cargo-input
                      :ref="'consigneeLine'+i"
                      v-model="form['consigneeLine'+i]"
                      :auto-uppercase="true"
                      @change="()=>wrapAddr(form,'consigneeLine'+i,i+1 > 6 ? null :'consigneeLine'+(i+1),45)"
                      @dblclick.native="showAdvanceTextDialog($t('SeaExport.Consignee'),mergeConsigneeLine(),splitConsigneeLine,true)"
                    />
                  </el-form-item>
                </div>
                <div>
                  <el-form-item :label="$t('SeaExport.NotifyParty')" class="custom">
                    <cargo-company-select
                      :method-params="{notify:true,active:true}"
                      :default-value="form.notifyId||''"
                      style="display: inline-block;width:173px;"
                      @change="data => {notifyChange(data)}"
                    />&nbsp;
                    <el-button
                      type="primary"
                      @click="billAddressDialog.visible=true"
                    >{{ $t('SeaExport.CodeSearching') }}</el-button>
                  </el-form-item>
                  <el-form-item v-for="i in 7" :key="i" class="label-none custom">
                    <cargo-input
                      :ref="'notifyLine'+i"
                      v-model="form['notifyLine'+i]"
                      :auto-uppercase="true"
                      @change="()=>wrapAddr(form,'notifyLine'+i,i+1 > 6 ? null :'notifyLine'+(i+1),45)"
                      @dblclick.native="showAdvanceTextDialog($t('SeaExport.NotifyParty'),mergeNotifyLine(),splitNotifyLine,true)"
                    />
                  </el-form-item>
                </div>
                <div>
                  <el-form-item :label="$t('SeaExport.SecondNotifyParty')" />
                  <el-form-item label-width="0" class="custom">
                    <cargo-input
                      v-model="form.alsoNotify"
                      :auto-uppercase="true"
                      type="textarea"
                      :rows="12"
                      @dblclick.native="showAdvanceTextDialog($t('SeaExport.SecondNotifyParty'),form.alsoNotify,val=>{form.alsoNotify=val},true)"
                    />
                  </el-form-item>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </el-form>
      <span slot="footer" style="padding:10px;">
        <el-button type="primary" @click="handleSubmit">{{ $t('SeaExport.Confirm') }}</el-button>
        <el-button @click="handleClose">{{ $t('SeaExport.Cancel') }}</el-button>
      </span>
    </el-dialog>

    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    ><cargo-rich-textarea
       v-model="advanceTextDialog.value"
       :disabled="readonly"
       style="height: 198px;"
     />
      <span slot="footer">
        <el-button v-show="isEdit" type="primary" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!-- HS编号和中文品名检索弹窗 -->
    <hs-code-search-dialog
      :visible.sync="hsCodeSearchDialog.visible"
      :title="hsCodeSearchDialog.title"
      @callback="hsCodeSearchDialog.successCallback"
    />
    <!-- 收发通地址弹窗 -->
    <bill-address-dialog
      :visible.sync="billAddressDialog.visible"
      :job="form"
      @callback="codeSearchCallback"
    />
  </div>
</template>
<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import * as ChargeMeasure from '@/class/cargo/model/parameters/ChargeMeasure'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { saveRailwayExport } from '@/api/railwayExport/reBooking'
import { validateReleaseNumberCustomer } from '@/api/company'
import { RailwayExportJob } from '@/class/model/booking/RailwayExportJob'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoInput from '@/components/Cargo/Common/cargoInput'
import cargoButtonContainer from '@/components/Cargo/Common/cargoButtonContainer'
import sopDialog from '@/components/Cargo/Job/sopDialog'
import bookingSeaEqDataGrid from '@/components/Cargo/Job/bookingSeaEqDataGrid'
import bookingBulkDataGrid from '@/components/Cargo/Job/bookingBulkDataGrid'
import bookingSpecialDataGrid from '@/components/Cargo/Job/bookingSpecialDataGrid'
import hsCodeSearchDialog from '@/components/Cargo/Job/hsCodeSearchDialog'
import cargoDepartmentNewSelect from '@/components/Cargo/Common/cargoDepartmentNewSelect'
import cargoDepartmentSelect from '@/components/Cargo/Common/cargoDepartmentSelect'
import cargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import cargoProjectSelect from '@/components/Cargo/Common/cargoProjectSelect'
import cargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import billAddressDialog from '@/components/Cargo/Job/billAddressDialog'
import { SEUtils } from '@/class/cargo/model/utils/SEUtils'
import { User } from '@/class/model/sys/User'
import * as CargoOfRoleType from '@/class/cargo/model/parameters/CargoOfRoleType'
import * as StuffyType from '@/class/cargo/model/parameters/StuffyType'
import { Company } from '@/class/model/mdm/Company'
import { Contract } from '@/class/model/mdm/Contract'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import { getLoading } from '@/utils/utilBaseElement'
import { cache, cacheName } from '@/utils/cacheManager'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import { multiply } from '@/utils/commonUtil'
import { CHARGE_SOURCE_SPLIT } from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'EditDialog',
  components: {
    cargoAdvanceSelect, cargoInput, cargoButtonContainer, sopDialog, bookingSeaEqDataGrid, bookingBulkDataGrid, bookingSpecialDataGrid,
    hsCodeSearchDialog, cargoDepartmentNewSelect, cargoDepartmentSelect, cargoOfficeSelect, cargoUserSelect, cargoCompanySelect, cargoProjectSelect,
    cargoPackingSelect, billAddressDialog, cargoRichTextarea, AutoNumberInput
  },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    jobModel: {
      type: Object,
      default: () => ({})
    },
    context: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      innerVisible: false,
      formInitialValue: {},
      selectTypeNames: TYPE_NAMES,
      form: new RailwayExportJob().fillDefaultValue().getData(),
      SEUtils,
      isSpecifiedSalesBusiness: false,
      chargeWeightCalculationMode: 0,
      salesOfficeCheck: false, // 是否按照分公司控制 (1:开启分公司过滤 0:关闭分公司过滤)
      seaEqList: [],
      cargoBulkDetailList: [],
      salesList: null,
      salesPrompt: '',
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null,
        isUppercase: false
      },
      hsCodeSearchDialog: {
        visible: false,
        title: '',
        successCallback: () => { }
      },
      billAddressDialog: {
        visible: false
      },
      loading: null
    }
  },
  computed: {
    config() {
      return this.context.config
    },
    job() {
      return this.form
    },
    readonly() {
      return !this.isEdit
    },
    isEdit() {
      return true
    }
  },
  watch: {
    visible: {
      async handler(newVal) {
        try {
          this.innerVisible = newVal
          if (newVal) {
            this.loading = getLoading('edit-dialog')
            await this.onShow()
          }
        } catch (err) {
          console.log(err)
        } finally {
          this.loading.close()
        }
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    const cacheConfig = cache.config
    this.innerVisible = this.visible
    this.isSpecifiedSalesBusiness = Number(cacheConfig.get('IsSpecifiedSalesBusiness')) === 1
    this.chargeWeightCalculationMode = ChargeUtils.getChargeWeightValueType(true) === 1
    this.salesOfficeCheck = Number(cacheConfig.get('SalesOfficeCheck')) === 1
  },
  methods: {
    async onShow() {
      const row = new RailwayExportJob(this.jobModel)
      await row.loadJobRelated({
        job: true,
        seaEQ: true,
        charges: true,
        containerUsages: true,
        cargoBulkDetail: true,
        containers: true
      })
      // 非主票 组装 containers.containerUsage  同 job.containerUsages 指向同一usage
      if (!row.masterFlag) {
        ContainerUtil.buildContainerUsages(row)
      }
      const job = new RailwayExportJob(row)
      this.seaEqList = job.seaEQ || []
      this.cargoBulkDetailList = job.cargoBulkDetail || []
      this.form = row
      if (!this.isSpecifiedSalesBusiness) {
        let officeSaleList = []
        if (this.salesOfficeCheck) {
          officeSaleList = await User.getUsersByPrivilegeDetail('role', 'sales', '', this.$store.getters.currentOfficeId)
        } else {
          officeSaleList = await User.getUsersByPrivilegeDetail('role', 'sales')
        }
        this.salesList = officeSaleList || []
      } else {
        this.loadCompanyUser() // 销售
      }
      this.formInitialValue = { ...this.form }
    },
    // 判断选中的委托单位，是否禁止到期合同创建业务，CARGO-7885
    async customerIdChange2ContractHandler(company) {
      this.contactList = []
      this.form.customerContact = ''
      if (!company || !company.cmpIdx) {
        this.form.customerId = 0
        this.form.sales = 0
        return
      }
      const validateRes = await validateReleaseNumberCustomer({
        companyId: company.cmpIdx,
        officeId: this.$store.getters.currentOfficeId
      })
      if (validateRes && validateRes.data && validateRes.data.allowed === false) {
        if (validateRes.data.message) {
          this.$message.warning(validateRes.data.message)
        }
        this.form.customerId = 0
        console.log('[ReleaseNumber] Railway Verify Edit clear', !!this.$refs.customerSelect)
        if (this.$refs.customerSelect && this.$refs.customerSelect.clear) {
          this.$refs.customerSelect.clear()
        }
        return
      }
      // 中邮委托单位是否黑名单
      const blacklist = await JobUtils.checkBlacklistByCustomerId(company.cmpIdx)
      if (blacklist) {
        // return
      }
      // 这个验证必须在 this.form.customerId = company.cmpIdx 赋值之前，否则此验证无意义
      SEUtils.refreshChargeAccountId(this.form, 'customerId', this.$t('SeaExport.ConsignationCompany'), this.context.modifiedData) // 这里返回true 说明修改了费用结算对象以及开票抬头，需要将费用参与保存
      this.form.customerId = company.cmpIdx

      company = new Company(company)
      const isForbid = await Contract.isContractExpiredForbidCreateJob(company.cmpIdx)
      if (isForbid) {
        this.form.customerId = 0
        this.$message.info(this.$t('Message.ContractExpireCannotCreated'))
        return
      }
      this.loadCompanyUser() // 销售
    },
    /**
     * 按业务指定销售
     */
    async loadCompanyUser() {
      const companyList = await getSpecificBasicData(basicCacheKeys.basic_data_Company)
      if (this.isSpecifiedSalesBusiness) {
        const company = companyList.find(p => p.cmpIdx === this.job.customerId)
        if (company) {
          Company.getCompanyUsers(company.uuid).then(data => {
            this.loadCompanyUserHandler(data)
          })
        }
      }
    },
    async loadCompanyUserHandler(companyUsers) {
      const job = this.job
      // 销售
      const salesList = []
      // 如果开启分公司过滤参数，查出来所有分公司
      let officeSaleList = []
      if (this.salesOfficeCheck) {
        officeSaleList = await User.getUsersByPrivilegeDetail('role', 'sales', '', this.$store.getters.currentOfficeId)
      }
      if (companyUsers && companyUsers.length > 0) {
        const userList = await getSpecificBasicData(basicCacheKeys.basic_data_User)
        for (const u of companyUsers) {
          if (!u.lob || u.lob === job.lob || u.lob === 'ALL') {
            const user = userList.find(p => p.userId === u.userId)
            if (user && user.active) {
              if (u.roleType === CargoOfRoleType.SALES_TYPE.code) { // 销售
                if (this.salesOfficeCheck) {
                  for (const obj of officeSaleList) {
                    if (user.userId === obj.userId) {
                      salesList.push(user)
                    }
                  }
                } else {
                  salesList.push(user)
                }
              }
            }
          }
        }
        this.salesList = salesList
      }
    },
    showHsCodeSearchDialog(title, successCallback) {
      this.hsCodeSearchDialog.title = title
      this.hsCodeSearchDialog.successCallback = successCallback
      this.hsCodeSearchDialog.visible = true
    },
    showAdvanceTextDialog(title, value, successCallback, isUppercase = false) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.isUppercase = isUppercase
      this.advanceTextDialog.visible = true
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    // 委托件毛体 更改事件 @change 事件中的 委托的 件毛体赋值 在此之后 导致 装箱数据仍是上一次的值
    async jobContractQwcChange(type) {
      if (type === 1) {
        await SEUtils.changeQWCRule(() => {
          this.job.quantityActual = this.job.quantityContract
        })
      } else if (type === 2) {
        await SEUtils.changeQWCRule(() => { this.job.weightActual = this.job.weightContract })
        this.calculateChargeWeight()
      } else if (type === 3) {
        await SEUtils.changeQWCRule(() => { this.job.cubageActual = this.job.cubageContract; this.job.chargeWeight = this.job.cubageContract })
        this.calculateChargeWeight()
      }

      this.refContainerUsageQwc(2, true)
    },
    refContainerUsageQwc(viewPager = 0, btnSave = true) {
      ContainerUtil.refContainerUsageQwc(this.job, viewPager, btnSave)
    },
    /**
     * 计费重量修改计算
     */
    async calculateChargeWeight() {
      try {
        let weight = this.chargeWeightCalculationMode === 1 ? parseFloat(this.job.weightContract) : parseFloat(this.job.weightActual)
        const cubage = this.chargeWeightCalculationMode === 1 ? parseFloat(this.job.cubageContract) : parseFloat(this.job.cubageActual)
        let chargeFlag = false
        if (isNaN(weight) || isNaN(cubage)) return
        weight = weight / 1000
        if (cubage > weight) {
          weight = cubage
        }
        if (weight > 0 && weight < 1) {
          weight = 1.00
        }
        this.job.chargeWeight = parseFloat(weight.toFixed(3))
        for (const charge of this.job.charges) {
          if (!charge.confirmBillUuid && !charge.diffChargeUuid && charge.chargeSource !== CHARGE_SOURCE_SPLIT.code && charge.measure === ChargeMeasure.WGTX_CHARGE_MEASURE.code) {
            chargeFlag = true
            break
          }
        }
        if (chargeFlag) {
          this.view.$confirm(this.view.$t('Message.TheChargedWeightHasBeenChangedThoseInvoicedAndBilledChargesWillNotBeUpdated'), {
            confirmButtonText: this.view.$t('common.btn.ok'),
            cancelButtonText: this.view.$t('common.btn.cancel'),
            type: 'warning'
          }).then(() => {
            for (const charge of this.job.charges) {
              if (!charge.confirmBillUuid && charge.measure === ChargeMeasure.WGTX_CHARGE_MEASURE.code &&
                !charge.invoiceUuid && !charge.billingUuid && !charge.billingPaymentUuid && !charge.diffChargeUuid && charge.chargeSource !== CHARGE_SOURCE_SPLIT.code &&
                !charge.verifiedAmount && !charge.paidOff) {
                charge.quantity = this.job.chargeWeight
                if (charge.unitPriceIncludeTax) {
                  ChargeUtils.calculateTaxAmount(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
                } else {
                  ChargeUtils.calculateTax(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
                }
              }
            }
          }).catch(() => {
          }).finally(() => {
          })
        }
        this.txtCubageActualFocusOutHandler(this.job.cubageActual)
      } catch (e) {
        // console.log('calculateChargeWeight error', e)
      }
    },
    /**
     * 发货人选择
     */
    async shipperChange(data) {
      const form = this.job
      form.shipperId = data.value
      const sycSCN = await parseInt(this.config.get('synchronousShipperCodeAndConsigneeCodeAndNotifyCode')) === 1
      if (form.shipperId) {
        // 将收发通代码同步至提单页签收发通代码(不考虑拆并单)
        const company = new Company(data)
        const manifestAddress = await company.getManifestAddress()
        if (manifestAddress) {
          form.shipperLine1 = manifestAddress.addressLine1
          form.shipperLine2 = manifestAddress.addressLine2
          form.shipperLine3 = manifestAddress.addressLine3
          form.shipperLine4 = manifestAddress.addressLine4
          form.shipperLine5 = manifestAddress.addressLine5
          form.shipperLine6 = manifestAddress.addressLine6
          form.shipperLine7 = manifestAddress.addressLine7
        } else {
          form.shipperLine1 = ''
          form.shipperLine2 = ''
          form.shipperLine3 = ''
          form.shipperLine4 = ''
          form.shipperLine5 = ''
          form.shipperLine6 = ''
          form.shipperLine7 = ''
        }
        await JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, sycSCN, 'shipper', 0, manifestAddress)
      } else {
        await JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, sycSCN, 'shipper', 0, null)
      }
    },
    /**
     * 收货人选择
     */
    async consigneeChange(data) {
      const form = this.job
      form.consigneeId = data.value
      const sycSCN = await parseInt(this.config.get('synchronousShipperCodeAndConsigneeCodeAndNotifyCode')) === 1
      // 将收发通代码同步至提单页签收发通代码(不考虑拆并单)
      if (form.consigneeId) {
        const company = new Company(data)
        const manifestAddress = await company.getManifestAddress()
        if (manifestAddress) {
          form.consigneeLine1 = manifestAddress.addressLine1
          form.consigneeLine2 = manifestAddress.addressLine2
          form.consigneeLine3 = manifestAddress.addressLine3
          form.consigneeLine4 = manifestAddress.addressLine4
          form.consigneeLine5 = manifestAddress.addressLine5
          form.consigneeLine6 = manifestAddress.addressLine6
          form.consigneeLine7 = manifestAddress.addressLine7
        } else {
          form.consigneeLine1 = ''
          form.consigneeLine2 = ''
          form.consigneeLine3 = ''
          form.consigneeLine4 = ''
          form.consigneeLine5 = ''
          form.consigneeLine6 = ''
          form.consigneeLine7 = ''
        }
        await JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, sycSCN, 'consignee', 0, manifestAddress)
      } else {
        await JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, sycSCN, 'consignee', 0, null)
      }
    },
    /**
     * 通知人选择
     */
    async notifyChange(data) {
      const form = this.job
      form.notifyId = data.value
      const sycSCN = await parseInt(this.config.get('synchronousShipperCodeAndConsigneeCodeAndNotifyCode')) === 1
      // 将收发通代码同步至提单页签收发通代码(不考虑拆并单)
      if (form.notifyId) {
        const company = new Company(data)
        const manifestAddress = await company.getManifestAddress()
        if (manifestAddress) {
          form.notifyLine1 = manifestAddress.addressLine1
          form.notifyLine2 = manifestAddress.addressLine2
          form.notifyLine3 = manifestAddress.addressLine3
          form.notifyLine4 = manifestAddress.addressLine4
          form.notifyLine5 = manifestAddress.addressLine5
          form.notifyLine6 = manifestAddress.addressLine6
          form.notifyLine7 = manifestAddress.addressLine7
        } else {
          form.notifyLine1 = ''
          form.notifyLine2 = ''
          form.notifyLine3 = ''
          form.notifyLine4 = ''
          form.notifyLine5 = ''
          form.notifyLine6 = ''
          form.notifyLine7 = ''
        }
        await JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, sycSCN, 'notify', 0, manifestAddress)
      } else {
        await JobUtils.synchronousShipperCodeAndConsigneeCodeAndNotifyCode(this.job, sycSCN, 'notify', 0, null)
      }
    },
    codeSearchCallback(data) {
      if (data.shipperInfo) {
        this.splitShipperLine(data.shipperInfo)
      }
      if (data.consigneeInfo) {
        this.splitConsigneeLine(data.consigneeInfo)
      }
      if (data.notifyInfo) {
        this.splitNotifyLine(data.notifyInfo)
      }
    },
    mergeShipperLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['shipperLine' + i] || ''
        result += '\n'
      }
      result += (this.form['shipperLine7'] || '')
      return result.trimEnd()
    },
    splitShipperLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['shipperLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['shipperLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['shipperLine' + i] = ''
      }
    },
    mergeConsigneeLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['consigneeLine' + i] || ''
        result += '\n'
      }
      result += (this.form['consigneeLine7'] || '')
      return result.trimEnd()
    },
    splitConsigneeLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['consigneeLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['consigneeLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['consigneeLine' + i] = ''
      }
    },
    mergeNotifyLine() {
      let result = ''
      for (let i = 1; i < 7; ++i) {
        result += this.form['notifyLine' + i] || ''
        result += '\n'
      }
      result += (this.form['notifyLine7'] || '')
      return result.trimEnd()
    },
    splitNotifyLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.form['notifyLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.form['notifyLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.form['notifyLine' + i] = ''
      }
    },
    // 保存
    async handleSubmit() {
      if (!this.validateForm()) return
      let company = null
      if (this.form.shipperId && parseInt(this.form.shipperId) > 0) {
        company = await Company.getCompanyById(this.form.shipperId)
        this.form.shipperCode = company ? company.shortName : ''
      }
      if (this.form.consigneeId && parseInt(this.form.consigneeId) > 0) {
        company = await Company.getCompanyById(this.form.consigneeId)
        this.form.consigneeCode = company ? company.shortName : ''
      }
      if (this.form.notifyId && parseInt(this.form.notifyId) > 0) {
        company = await Company.getCompanyById(this.form.notifyId)
        this.form.notifyCode = company ? company.shortName : ''
      }
      if (this.form.warehousing) {
        this.form.loadingTerm = StuffyType.IS_STUFFY_TYPE.code
      } else if (this.form.landTransportation) {
        this.form.loadingTerm = StuffyType.DD_STUFFY_TYPE.code
      } else {
        this.form.loadingTerm = StuffyType.SD_STUFFY_TYPE.code
      }

      // 车队
      // 已经拼箱的业务支持货物数量直接更改
      ContainerUtil.refContainerUsageQwc(this.form)

      // console.log('this.form=======', this.form)
      const job = { ...this.form }
      this.cleanCircleObject(job._data)
      const obj = {
        job: job._data,
        seaEQ: this.seaEqList,
        charges: this.form.charges,
        delseaEQUuids: this.form.delseaEQUuids,
        cargoBulkDetailList: this.cargoBulkDetailList,
        containers: this.form.containers, // this.form.containers.filter(p => p.isDirty === true), // 实际件毛体 更改影响装箱数据未标记isDirty，后续根据需要再处理
        delContainerUuids: this.form.delContainerUuids, // 删除的箱子uuid
        delContainerUsageUuids: this.form.delContainerUsageUuids // 删除的装箱uuid
      }
      this.loading = getLoading()
      await saveRailwayExport(obj).then(res => {
        this.$message.success('修改成功')
        this.$emit('reloadFunc', res.data.job)
      }).finally(() => {
        this.handleClose()
        this.loading.close()
      })
    },
    // 清理循环引用
    cleanCircleObject(obj, level = 0, refMap = new Map()) {
      if (!(obj instanceof Object)) {
        return
      }
      if (level === 0) {
        refMap.set(obj, { level })
      }
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          const item = obj[key]
          if (item instanceof Object) {
            const ref = refMap.get(item)
            if (ref) {
              if (level > ref.level) {
                if (obj instanceof Array) {
                  obj[key] = undefined
                } else {
                  delete obj[key]
                }
              } else if (level < ref.level) {
                if (ref.parent instanceof Array) {
                  ref.parent[ref.name] = undefined
                } else {
                  delete ref.parent[ref.name]
                }
                ref.level = level
                ref.parent = obj
                ref.name = key
              }
            } else {
              refMap.set(item, { level: level + 1, parent: obj, name: key })
              this.cleanCircleObject(item, level + 1, refMap)
            }
          }
        }
      }
      if (level === 0) {
        for (const arr of refMap.keys()) {
          if (arr instanceof Array) {
            // 从后向前删除，避免待删除元素的index发生变化
            for (let i = arr.length - 1; i >= 0; --i) {
              if (typeof arr[i] === 'undefined') {
                arr.splice(i, 1)
              }
            }
          }
        }
      }
    },
    validateForm() {
      const form = this.form
      if (!form.sales || parseInt(form.sales) <= 0) {
        this.$message.warning(this.$t('Message.SalesCannotBeNull'))
        return false
      }
      if (!form.customerId || form.customerId < 1) {
        this.$message.warning(this.$t('Message.ConsignationCompanyCannotBeNull'))
        return false
      }

      const bookingIsOpenSaleCheck = parseInt(this.config.get('BookingIsOpenSaleCheck')) === 0
      if (parseInt(form.sales) !== parseInt(this.$store.getters.userId) && !bookingIsOpenSaleCheck) {
        this.$message.warning(this.$t('Message.DearYouCanOnlySelectYourOwnCustomers'))
        return false
      }
      if ((form.containerLoadType === 'FCL' || form.containerLoadType === 'BB') && this.seaEqList && this.seaEqList.length > 0) {
        if (!form.seaEQ) form.seaEQ = this.seaEqList
        if (ContainerUtil.checkNoDuplationSeaEQ(form)) {
          this.$message.warning(this.$t('SeaExport.RepeatBoxType'))
          return false
        }
      }
      return true
    },
    handleClose() {
      this.innerVisible = false
    },
    wrapAddr(source, from, to, maxChars) {
      CargoDocUtil.sftAddrInputWrap.call(this, source, from, to, maxChars)
    }
  }
}
</script>
<style lang="scss">
.edit-dialog {
  .el-dialog {
    &__header, &__body, &__footer {
      padding: 10px 15px !important;
    }

    &__title {
      vertical-align: middle;
    }

    &__headerbtn {
      top: 15px;
      right: 15px;
    }

    &__body {
      overflow: auto;
      padding:0!important;
      .el-form {
        margin: 10px;
        overflow: auto;
      }
      .form-content-wrapper{
        width: fit-content;
        .up {
          display: flex;
          flex-direction: row;
        }
        .down {
          display: flex;
          fieldset{
            flex: 1;
            width: 100%;
          }
          .custom-delivery-info-wrapper{
            display: flex;
            flex-direction: row;
            &>div{
              flex: none;
              margin: 0 5px;
            }
          }
        }
        fieldset{
          flex: none;
          .el-form-item__content{
            width: 190px;
          }
          .custom, .label-none {
            .el-form-item__content{
              width: auto;
              min-width: 190px!important;
            }
          }
        }
      }
      fieldset {
        padding-bottom: 0;
        border-style: solid;
        border-color: #dfe4ed;
      }
    }
  }
}
</style>
